var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLxp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.4286 19.25H43.8214C40.6112 19.25 38 21.8843 38 25.1228V53.2169C38 56.4554 40.6112 59.0897 43.8214 59.0897H73.5755L84.5475 65.0833V59.0897H88.4286C91.6388 59.0897 94.25 56.4554 94.25 53.2169V25.1228C94.25 21.8843 91.6388 19.25 88.4286 19.25Z",
    fill: "url(#paint0_linear_2589_9550)",
    fillOpacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.666 27.2568H48.416V29.822H79.666V27.2568Z",
    fill: "#0075F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1955 34.3076H48.416V36.8728H69.1955V34.3076Z",
    fill: "#0075F8"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 3.5,
    y: 37.5,
    width: 66.25,
    height: 55.8335
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_0_2589_9550_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 5,
    d: "M14.3214 42.5H58.9286C62.1388 42.5 64.75 45.1343 64.75 48.3728V76.4669C64.75 79.7054 62.1388 82.3397 58.9286 82.3397H29.1745L18.2025 88.3333V82.3397H14.3214C11.1112 82.3397 8.5 79.7054 8.5 76.4669V48.3728C8.5 45.1343 11.1112 42.5 14.3214 42.5Z",
    fill: "url(#paint1_linear_2589_9550)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2589_9550_clip_path",
    transform: "translate(-3.5 -37.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3214 42.5H58.9286C62.1388 42.5 64.75 45.1343 64.75 48.3728V76.4669C64.75 79.7054 62.1388 82.3397 58.9286 82.3397H29.1745L18.2025 88.3333V82.3397H14.3214C11.1112 82.3397 8.5 79.7054 8.5 76.4669V48.3728C8.5 45.1343 11.1112 42.5 14.3214 42.5Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2589_9550",
    x1: 37.5,
    y1: 19.5,
    x2: 114.5,
    y2: 79.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2589_9550",
    x1: 8.5,
    y1: 47.5,
    x2: 98,
    y2: 83.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLxp);
export default __webpack_public_path__ + "static/media/LXP.acdadbf077a071671b81a4a62d9684f6.svg";
export { ForwardRef as ReactComponent };